module.exports = __webpack_public_path__ + "static/Sustain_Health-9284e38877e860180703224043f8e347.png";